import clsx from "clsx";
import { useEffect } from "react";
import { useTimer } from "react-timer-hook";

const formatTime = (value: number) => value.toString().padStart(2, "0");

export default function MyTimer({
  expiryTimestamp,
  onExpire,
  cx
}: {
  expiryTimestamp: Date;
  onExpire: () => void;
  cx?: string
}) {
  const { seconds, minutes, restart } = useTimer({
    expiryTimestamp,
    autoStart: true,
    onExpire,
  });

  useEffect(() => {
    restart(expiryTimestamp, true);
  }, [expiryTimestamp, restart]);

  const secondsLeft = formatTime(seconds);
  const minutesLeft = formatTime(minutes);

  return (
    <div
      className={clsx(
        "text-2xl font-mono",
        parseInt(secondsLeft) < 20 &&
        parseInt(minutesLeft) === 0 &&
        "text-myRed",
        cx
      )}
    >
      <span>{minutesLeft}</span>:<span>{secondsLeft}</span>
    </div>
  );
}
